import { useMutation } from "@apollo/client";
import {
  DELETE_GOOGLE_REVIEW_REPLY_MUTATION,
  REPLY_TO_GOOGLE_REVIEW_MUTATION,
} from "@/graphql/google-business";
import { useAsyncAction } from "@/lib/hooks/use-async-action";

export function useGoogleReviewReply() {
  const [reply] = useMutation(REPLY_TO_GOOGLE_REVIEW_MUTATION);
  const [deleteReply] = useMutation(DELETE_GOOGLE_REVIEW_REPLY_MUTATION);

  const submitReply = useAsyncAction(
    async (reviewId: string, text: string) => {
      const result = await reply({
        variables: { reviewId, text },
        refetchQueries: ["SalonReviews"],
      });
      return result.data?.replyToGoogleReview;
    },
    {
      loadingMessage: "Sending reply...",
      successMessage: "Reply saved",
      errorMessage: "Could not save reply",
    }
  );

  const removeReply = useAsyncAction(
    async (reviewId: string) => {
      const result = await deleteReply({
        variables: { reviewId },
        refetchQueries: ["SalonReviews"],
      });
      return result.data?.deleteGoogleReviewReply;
    },
    {
      loadingMessage: "Deleting reply...",
      successMessage: "Reply deleted",
      errorMessage: "Could not delete reply",
    }
  );

  return {
    submitReply: submitReply.execute,
    submitting: submitReply.isLoading,
    removeReply: removeReply.execute,
    removing: removeReply.isLoading,
  };
}
